import axios from 'axios';

/**
 * Global axios interceptor pro řešení stale JWT tokenu.
 *
 * Pokud jakýkoliv admin endpoint vrátí 401 (neplatný / expirovaný / stale
 * strukturní token), token automaticky vyčistíme, aby uživatel byl přesměrován
 * na přihlašovací obrazovku místo nekonečné smyčky s nefunkčními požadavky.
 *
 * Aplikuje se pouze pro chráněné endpointy pod `/api/admin/` a `/api/cms/`,
 * aby veřejné API (analytics event, veřejné čtení stránek) nevyvolávalo logout.
 */
let interceptorInstalled = false;

export function installAxiosAuthInterceptor() {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const status = error?.response?.status;
        const url = error?.config?.url || '';
        const isProtected = /\/api\/(admin|cms|ai)\b/.test(url);
        if (status === 401 && isProtected) {
          const hadToken = !!localStorage.getItem('admin_token');
          if (hadToken) {
            console.warn('[Auth] 401 on protected endpoint - clearing stale admin_token', url);
            localStorage.removeItem('admin_token');
            // Když jsme uvnitř admin panelu, force reload zobrazí login formulář.
            if (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')) {
              window.location.reload();
            }
          }
        }
      } catch (e) {
        // interceptor nesmí házet
      }
      return Promise.reject(error);
    }
  );
}
